import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const HttpClientContext = /*#__PURE__*/createContext(null);
export function HttpClientContextProvider({
  httpClient,
  children
}) {
  return /*#__PURE__*/_jsx(HttpClientContext.Provider, {
    value: httpClient,
    children: children
  });
}
export function useHttpClient() {
  const value = useContext(HttpClientContext);
  if (value === null) {
    throw new Error('useHttpClient must be used within a HttpClientContextProvider');
  }
  return value;
}